import { render, staticRenderFns } from "./StreamPlayerWebRtc.vue?vue&type=template&id=380bb6a6"
import script from "./StreamPlayerWebRtc.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamPlayerWebRtc.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports